/**
 * Runtime config for the Strategy4Kids app.
 *
 * LOCALE_ENABLED gates the locale (FR/ES) feature work behind a feature flag.
 * Default is `false` so we ship English-only behind the door (per the locale
 * spec §8.1). Flip to `true` once FR/ES translations are human-reviewed
 * (spec Phase 1 / Phase 2).
 *
 * SUPPORTED_LOCALES in Phase 2: ['en', 'fr', 'es'] when LOCALE_ENABLED.
 * Spanish is now selectable at runtime — its JSON is lazy-loaded from
 * `apps/app/public/locales/es/` exactly as FR is, and `pnpm i18n:check`
 * guards both key parity against `en/**` and the public mirror against
 * source, so a stale mirror cannot silently serve English.
 *
 * The site (`apps/site`) deliberately stays `supportedLngs: ['en']` — its
 * locale selection is Phase 3 (LocaleSwitcher + SEO routes), per spec §8.2.
 */
export const LOCALE_ENABLED =
  import.meta.env.VITE_LOCALE_ENABLED === 'true';

export const SUPPORTED_LOCALES = LOCALE_ENABLED
  ? (['en', 'fr', 'es'] as const)
  : (['en'] as const);

export const DEFAULT_LOCALE = 'en' as const;